import { FormattedMessage } from 'react-intl';

import {
  FIELD_AMOUNT,
  FIELD_DATE,
  FIELD_MEMBERS,
  FIELD_MEMBER_SELECTED,
  COMMON_FIELD_NAMES,
} from './constants.fields';
import { validateNoSpecialChars } from 'utils/validateNoSpecialChars';

export const MSG_SOLD_ASSETS = 'afforda.assets.details.soldAssets';

const assetTypeOptions = [
  {
    label: (
      <FormattedMessage id="afforda.assets.details.soldAssets.assetType.realState" />
    ),
    value: 'Real State/Land/Property',
  },
  {
    label: (
      <FormattedMessage id="afforda.assets.details.soldAssets.assetType.401k" />
    ),
    value: '401K/IRA/Roth/Keogh',
  },
  {
    label: (
      <FormattedMessage id="afforda.assets.details.soldAssets.assetType.charitable" />
    ),
    value: 'Charitable Contributions/Donations',
  },
  {
    label: (
      <FormattedMessage id="afforda.assets.details.soldAssets.assetType.monetaryGifts" />
    ),
    value: 'Monetary Gifts',
  },
  {
    label: (
      <FormattedMessage id="afforda.assets.details.soldAssets.assetType.lotteryWinnings" />
    ),
    value: 'Lottery Winnings',
  },
  {
    label: (
      <FormattedMessage id="afforda.assets.details.soldAssets.assetType.lumpSum" />
    ),
    value: 'Lump Sum Payment',
  },
  {
    label: (
      <FormattedMessage id="afforda.assets.details.soldAssets.assetType.other" />
    ),
    value: 'Other',
  },
];

export const SOLD_ASSETS_FIELD_NAMES = {
  assetType: 'assetType',
  otherAssetType: 'otherAssetType',
  dateSold: 'dateSold',
  marketValue: COMMON_FIELD_NAMES.marketValue,
  salePrice: 'salePrice',
};

export const FIELDS = ({ intl, members, disabledMembers, getValues }) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    // Amount
    {
      ...FIELD_MEMBER_SELECTED,
      name: SOLD_ASSETS_FIELD_NAMES.assetType,
      multiselect: true,
      label: intl.formatMessage({
        id: 'afforda.assets.details.soldAssets.assetType',
      }),
      variant: 'buttonGroup',
      options: assetTypeOptions,
      helperText: intl.formatMessage({
        id: 'afforda.assets.details.soldAssets.assetTypeHelperText',
      }),
      direction: 'column',
    },
    // Other Asset Type
    {
      ...FIELD_MEMBER_SELECTED,
      variant: 'text',
      label: (
        <FormattedMessage id="afforda.assets.details.soldAssets.otherAssetType" />
      ),
      name: SOLD_ASSETS_FIELD_NAMES.otherAssetType,
      placeholder: intl.formatMessage({
        id: 'afforda.assets.details.soldAssets.otherAssetType',
      }),
      rules: {
        required: ({ getValues }) => {
          return getValues().assetType?.includes('Other');
        },
        validate: validateNoSpecialChars,
      },
      hidden: ({ getValues }) => {
        return !getValues().assetType?.includes('Other');
      },
    },
    // Date Sold
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_DATE,
      label: (
        <FormattedMessage id="afforda.assets.details.soldAssets.dateSold" />
      ),
      name: SOLD_ASSETS_FIELD_NAMES.dateSold,
      GridProps: {
        xs: 12,
        sm: 6,
      },
    },
    // Market Value
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_AMOUNT,
      label: (
        <FormattedMessage id="afforda.assets.details.soldAssets.marketValue" />
      ),
      placeholder: '0.00',
      name: SOLD_ASSETS_FIELD_NAMES.marketValue,
    },
    // Sale Price
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_AMOUNT,
      label: (
        <FormattedMessage id="afforda.assets.details.soldAssets.salePrice" />
      ),
      placeholder: '0.00',
      name: SOLD_ASSETS_FIELD_NAMES.salePrice,
      rules: {
        ...FIELD_AMOUNT.rules,
        validate: (value) => {
          const marketValue = getValues().marketValue;
          const floatValue = parseFloat(value);
          const floatMarketValue = parseFloat(marketValue);

          if (
            !isNaN(floatValue) &&
            !isNaN(floatMarketValue) &&
            floatValue > floatMarketValue
          ) {
            return intl.formatMessage({
              id: 'afforda.assets.details.soldAssets.salePriceValidation',
            });
          }
        },
      },
    },
  ];
};
